
import {
  required,
  minLength,
} from 'vuelidate/lib/validators';
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default {
  name: 'PopUpSendIpoteka',

  data() {
    return {
      form: {
        name: '',
        phone: '',
      },
      consentPersonalInfo: false,
    };
  },

  validations() {
    const form = {
      name: {
        required,
      },
      phone: {
        required,
        minLength: minLength(18),
      },
    };

    return {
      form,
    };
  },

  computed: {
    isOpen() {
      return this.$store.state['pop-up-ipoteka-call']?.isOpen || false;
    },
    settings() {
      return this.$store.state['pop-up-ipoteka-call']?.settings || {};
    },

    title() {
      return this.settings.title || 'Форма заявки на ипотеку';
    },
    message() {
      return this.settings.message || '';
    },
    formType() {
      return this.settings.formType || 'Одобрение ипотеки';
    },
    additionalData() {
      return this.settings?.additional_data || null;
    },

    errorName() {
      const error = this.$v?.form?.name;
      if (!error?.$invalid || !error?.$dirty) {
        return null;
      }

      if (!error.required) {
        return 'Обязательно к заполнению';
      }

      return null;
    },
    errorPhone() {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null;
      }

      if (!error.required) {
        return 'Обязательно к заполнению';
      }
      if (!error.minLength) {
        return 'Неправильный формат ввода';
      }

      return null;
    },
    path() {
      if (!process.client) {
        return String(this.$route.path);
      }
      return String(window.location);
    },
  },

  methods: {
    close() {
      this.form = {
        name: '',
        phone: '',
      };
      this.$v.$reset();
      this.$store.commit('pop-up-ipoteka-call/setOpen', false);
    },

    async submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      const bodyForIpotekaMortgages = {
        params: {
          ...this.settings.params,
          phone: this.form.phone,
          name: this.form.name,
          //amount: String(Number(this.settings.params.price) - Number(this.settings.params.initialPayment)),
          pageUrl: this.path,
        }
      }

      const responseIpotekaCall = await this.$api.transport.post('/banks/send-application', bodyForIpotekaMortgages).then((res) => res.data).catch((err) => ({
        error: errorParseNetwork(err.response),
      }));
      if (responseIpotekaCall.error) {
        this.$toast.error(responseIpotekaCall.error);
        return;
      }

      this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: true });

      const body = {
        type: this.formType,
        name: this.form.name,
        phone: (this.form?.phone || '').replace(/[^\d]/g, ''),
        url: window.location.href,
      };
      if (this.message) {
        body.message = this.message;
      }
      if (this.additionalData) {
        body.additional_data = this.additionalData;
      }
      body.source = this.$cookies.get('sbjs_current') || '';
      const response = await this.$api.agent.transport.post('/form/send', body).then((res) => res.data).catch((err) => ({
        error: errorParseNetwork(err.response),
      }));
      if (response.error) {
        this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: false });

        this.$toast.error(response.error);

        return;
      }

      if (this.settings?.reachGoal) {
        this.$yandexMetrika.reachGoal(this.settings?.reachGoal);
      }

      this.$store.commit('loading/setLoading', { name: 'popUpLoading', value: false });
      this.$store.commit('pop-up-success-form/setOpen', true);
      this.close();
    },
  },
};
